<template>
    <v-layout v-if="Object.keys(user).length" row justify-center>
        <v-flex v-if="user.courses_stat" class="lg4 text-xs-center text-md-left">
            <profileStat :number="user.courses_stat.completed.stat || 0" :text="$t('Курсов пройдено')" color="green" />
        </v-flex>
        <v-flex class="lg4 text-xs-center text-md-left">
            <profileStat :number="user.organization_rating.position || 0" :text="$t('Место в своей организации')" color="red" />
        </v-flex>
        <v-flex class="lg4 text-xs-center text-md-left">
            <profileStat :number="user.total_rating.position || 0" :text="$t('Место в общем рейтинге')" color="text" />
        </v-flex>
    </v-layout>
</template>

<script>
import profileStat from './user_profile_stat';

export default {
  components: {
    profileStat,
  },
  props: {
    user: {
      type   : Object,
      default: () => Object.create(null),
    },
  },
};
</script>

